<template>
  <BaseSelect
    v-model="model"
    :options="icons"
    selected-label=""
    class="icon-picker-multiselect"
    :class="{'icon-picker-multiselect--extended': extended}"
  >
    <template
      slot="singleLabel"
      slot-scope="props"
    >
      <DisplayIcon
        :extended="extended"
        :id="props.option.id || props.option"
      />
    </template>

    <template
      slot="option"
      slot-scope="props"
    >
      <DisplayIcon
        :extended="extended"
        :id="props.option.id || props.option"
      />
    </template>
  </BaseSelect>
</template>

<script>
import { mapGetters } from 'vuex';
import DisplayIcon from './DisplayIcon.vue';
import BaseSelect from './BaseSelect.vue';

export default {
    name: 'IconPicker',
    components: { BaseSelect, DisplayIcon },
    props: {
        extended: { type: Boolean, default: false },
        value: { type: Number, required: true },
    },
    computed: {
        ...mapGetters('icons', [
            'getAllIcons',
            'getAllStatusIcons',
        ]),
        iconList() {
            return this.extended ? this.getAllStatusIcons : this.getAllIcons;
        },
        icons() {
            return Object.values(this.iconList);
        },
        model: {
            get() {
                return this.value;
            },
            set(newValue) {
                this.$emit('input', this.value === newValue.id ? -1 : newValue.id);
            },
        },
    },
};
</script>
